import { classifyColumnData } from '../utils';
export var createColumnSelectionEvent = function (_a) {
    var data = _a.data, formatters = _a.formatters, selectedColumns = _a.selectedColumns;
    var selection = [];
    selectedColumns.forEach(function (_a) {
        var columnName = _a.columnName;
        var formatter = formatters === null || formatters === void 0 ? void 0 : formatters[columnName];
        selection.push({
            name: columnName,
            formatter: typeof formatter === 'string' ? formatter : null,
            dataType: classifyColumnData(columnName, data),
        });
    });
    return {
        eventName: '@table/columns-selected',
        meta: {
            selection: selection,
        },
    };
};
